<template>
  <div>
  <lateralNavigation2></lateralNavigation2>
  <rightNav></rightNav>
  <div style="background-color: #f2f2f2;height: 2px;margin-top: 10px;"></div>
    <div class="productBox warp">
      <!-- 商品详情顶部导航  和  分层标签 -->
      <div style="">
        <div style="font-size: 16px;height: 64px;display: flex;justify-content: flex-start;align-items: center;">
          <div class='head'>
            <div class='all'>全部结果</div>
            <div class='arrow'></div>
            <div v-for="(item, index) of storeCategory"
            :key="index" style="display: flex;justify-content: flex-start;align-items: center;">
              <div class='keyword'>{{item.cateName}}</div>
              <div class='arrow' v-if="index!==2"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="productConcise clearfix ">
        <div class="swiper-box" style="height: 530px;">
          <!-- swiper1 -->
          <swiper
            :options="swiperOptionTop"
            class="gallery-top"
            ref="swiperTop">
          <!-- 中间的大图 -->
            <swiper-slide
              v-for="(item, index) of productDetailData.sliderImageArr"
              :key="index"
              :style="{ backgroundImage: 'url(' + item + ')' }"
              :class="swiper-no-swiping"
            ></swiper-slide>

          </swiper>
          <!-- swiper2 Thumbs -->
          <div class="swiperThumbsLeft">
            <div class="thumbsBox">
              <!-- 上下滑动轮播图 -->
              <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
                <swiper-slide
                  v-for="(item, index) of productDetailData.sliderImageArr"
                  :key="index" :style="{ backgroundImage: 'url(' + item + ')'}">
                  <div style="width: 100%; height: 100%" @click="thumbsClick(index)"></div>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
        <div class="proDuctInfo">
          <h3 class="productTit">{{ productDetailData.storeName }}</h3>
          <div class="priceDataInfo">
            <div class="promotionInfo">
              <span>型号:</span>
              <span>{{ currentProductData.model}}</span>
            </div>
            <br/>
            <div class="promotionInfo">
              <span>价格:</span>
              <span>￥{{ currentProductData.price }}</span>
            </div>
            <div class="proDiscount">
              <div
                class="activityLabel"
                v-for="(item, index) of Discount"
                :key="index"
              >
                <span>{{ item.cname }}</span>
                <span
                  >优惠券：满{{ item.useMinPrice }}减{{
                    item.couponPrice
                  }}</span
                >
                <span @click="getThisCoupon(item, index)">{{
                  !item.isUse ? "领取" : "已领取"
                }}</span>
              </div>
            </div>
          </div>

          <div class="productNumber">
            <dl class="prop-item clearfix prop-service">
              <dl class="prop-item clearfix prop-service">
                <dt>库&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;存</dt>
                <dd>
                  <span class="fl stock-red" v-if="currentProductData.stock>10"
                  >有货
                </span
                >
                  <span class="fl stock-red" v-if="0<currentProductData.stock && currentProductData.stock<=10"
                  >库存<b>{{ currentProductData.stock }}</b
                  >件</span
                  >
                  <span class="fl stock-red" v-if="currentProductData.stock==0"
                  >无货</span
                  >
                </dd>
              </dl>
              <dl class="prop-item clearfix prop-service">
                <dt>服&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务</dt>
                <dd>
                  <span>由铭鸿鑫商城销售和发货，并享受售后服务</span>
                </dd>
              </dl>
              <dl class="prop-item clearfix prop-service">
                <dt>品&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;牌</dt>
                <dd>
                  <span>{{currentProductData.brandName}}</span>
                </dd>
              </dl>
              <dl class="prop-item clearfix prop-service">
                <dt>数&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;量</dt>
                <dd>
                  <el-input-number
                    v-model="productNumber"
                    :min="1"
                    :max="currentProductData.stock"
                    label="库存"/>
                </dd>
              </dl>
            </dl>
          </div>
          <div style="margin-top: 10px;">
              <el-button v-if="productDetailData.userCollect == false" @click="collect('收藏')" size="mini" type="success">收藏</el-button>
              <el-button v-else size="mini" @click="collect('取消收藏')" type="success">取消收藏</el-button>
          </div>
          <div class="buyBox">
            <span @click="buyGood">购买</span>
            <span @click="clickAddCart()">加入购物车</span>
          </div>
        </div>
      </div>
      <div class="productDetail">
        <div class="detailTabs">
          <span
            :class="{ compActive: currentComp === 'detailData' }"
            @click="clickSwitchTab((type = 'detailData'))"
            >宝贝详情</span
          >
          <span
            :class="{ compActive: currentComp === 'specifications' }"
            @click="clickSwitchTab((type = 'specifications'))"
            >商品规格</span
          >
          <span
            :class="{ compActive: currentComp === 'evaluation' }"
            @click="clickSwitchTab((type = 'evaluation'))"
            >商品评论</span
          >
        </div>
        <div class="detailBox clearfix">
          <div class="detailInfoBox">
            <div v-show="currentComp === 'detailData'">
              <div class="detailBox">
                <div class="detailContent" v-html="productDetailData.description"></div>
              </div>
            </div>
            <div v-show="currentComp === 'evaluation'">
              <!-- v-if="evaluateParam.productId !== ''" -->
              <div class="evaluationBox">
                <div class="evaluateType">
                  <span
                    @click="changeEvaType('全部', 0)"
                    >全部（{{ evaluateCount }}）</span
                  >
                </div>
                <div class="evaluateList">
                  <div
                    class="evaluateItem"
                    v-for="(item, index) of evaluateList"
                    :key="index"
                    style="margin: 15px;"
                  >
                    <div class="leftAvatarBox">
                      <!-- <img :src="item.avatar" style="width: 50px;height: 50px;" alt="" /> -->
                      <el-avatar :src="item.avatar"></el-avatar>
					<el-rate disabled-void-color="#E5E5E5" disabled class="mar-bot-10" v-model="item.star"></el-rate>
                      <!-- <span>{{ item.comment }}</span> -->
                    </div>
                    <div class="evaluateInfo">
                      <p> {{ item.comment }}</p>
                      <div class="evaluateImgList" v-if="item.impicturesArrages">
                        <!-- <div
                          class="imgItemBox"
                          v-for="(imgItem, index) of item.impicturesArrages"
                          :key="index"
                        >
                          <img :src="imgItem" alt="" />
                        </div> -->
                        <el-carousel :interval="5000" indicator-position="outside">
                            <el-carousel-item v-for="(imgItem, index) in item.impicturesArrages" :key="index">
                              <img :src="imgItem" alt="" />
                            </el-carousel-item>
                          </el-carousel>
                      </div>
                      <div style="color: darkgray;" v-if="item.merchantReplyContent">
                        回复:{{item.merchantReplyContent}}
                      </div>
                      <div class="evaluateTime">{{ item.createTime }}</div>
                      <div class="addToEvaInfo" v-if="item.addComment">
                        <span>{追加评论}</span>
                        <span>{{ item.addComment }}</span>
                      </div>
                      <div class="evaluateImgList" v-if="item.picturesArr.length > 0">
                        <!-- <div
                          class="imgItemBox"
                          v-for="(imgItem, index) of item.picturesArr"
                          :key="index"
                        >
                          <img :src="imgItem" alt="" />
                        </div> -->
                        <el-carousel :interval="5000" indicator-position="outside">
                            <el-carousel-item v-for="(imgItem, index) in item.picturesArr" :key="index" style="display: flex;justify-content: center;">
                              <img :src="imgItem" alt=""/>
                            </el-carousel-item>
                          </el-carousel>
                      </div>
                      <div class="receiptTime" v-if="item.day">
                        确认收货后{{ item.day }}天追加
                      </div>
                    </div>
                    <!-- <div style="height: 5px;width: 100%;background-color: #f0eeee;"></div> -->
                  </div>
                  <el-pagination
                    class="evaluationPage"
                    background
                    layout="prev, pager, next, jumper"
                    :page-size="5"
                    :current-page="listPage"
                    :total="pageTotal"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
			<div v-if="evaluateCount == 0 && currentComp === 'evaluation'" class="noData">暂无评论</div>
            <div v-if="specifica != null">
              <div
                v-show="currentComp === 'specifications'"
                v-for="(item, index) of specifica[0]"
                :key="index"
              >
                <el-row :gutter="20">
                  <el-col :span="6"
                    ><div class="grid-content bg-purple">
                      <span v-if="item[0]">{{item[0]['fid']}}</span>
                    </div></el-col>
                  <el-col :span="6">
                    <div
                      v-show="currentComp === 'specifications'"
                      v-for="(item2, index2) of item"
                      :key="index2"
                    >
                      <div class="grid-content bg-purple">{{ item2.id }}</div>
                    </div>
                  </el-col>
                  <el-col :span="6">
                    <div
                      v-show="currentComp === 'specifications'"
                      v-for="(item2, index2) of item"
                      :key="index2"
                    >
                      <div class="grid-content bg-purple">{{ item2.num }}</div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
			<div v-if="specifica == null && currentComp === 'specifications'" class="noData">暂无数据</div>
          </div>
          <div class="likeProductBox">
            <like-list
              @reloadDetail="reloadDetail"
              :similarProducts="similarProducts"
            ></like-list>
          </div>
        </div>
      </div>
    </div>
<!--    <serve></serve>-->
  </div>
</template>

<script>
import Serve from '../../components/serve/serve'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import detailData from './detailData'
import evaluation from './evaluation'
import likeList from './likeList'
import 'swiper/dist/css/swiper.css'
import CereHeader from '../../components/canvasShow/slwshop/home/header'
import api from '../../api'
import { listSearchMixin } from '../../config/mixin'
import { mapGetters, mapMutations } from 'vuex'
import Cookie from 'js-cookie'
import rightNav from '../../components/canvasShow/rightNav'
import lateralNavigation2 from '../../components/base/lateralNavigation2'

export default {
  name: 'productDetail',
  mixins: [listSearchMixin],
  components: {
    lateralNavigation2,
    rightNav,
    Serve,
    CereHeader,
    swiper,
    swiperSlide,
    detailData,
    evaluation,
    likeList
  },
  inject: ['reload'],
  data () {
    return {
      showMenu: true,
      sstt: [
        'itemMenu1',
        'itemMenu2',
        'itemMenu3',
        'itemMenu4',
        'itemMenu5',
        'itemMenu6',
        'itemMenu7',
        'itemMenu8',
        'itemMenu9'
      ],
      categoryMenu: null,
      storeCategory:[
        {
          cateName: '家用电器'
        },
        {
          cateName: '空调'
        }
      ],
      currentComp: 'detailData',
      swiperTop: null,

      swiperThumbs: null,
      swiperOptionTop: {
        spaceBetween: 10,
        loop: true,
        loopedSlides: 20
      },
      swiperOptionThumbs: {
        navigation: {
          // nextEl: '.swiper-button-next',
          // prevEl: '.swiper-button-prev'
        },
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 5,
        loop: true,
        freeMode: true,
        loopedSlides: 20, // looped slides should be the same
        centeredSlides: true,
        watchSlidesVisibility: true
      },
      productSizeData: {},
      productColor: {},
      productDetailData: {},
      activeName: 'Detail',
      productOption: {},
      evaluateParam: {
        productId: '',
        words: []
      },
      similarProducts: [],
      productPrice: '',
      originalPrice: '',
      currentProductData: {
        price: 0,
        otPrice: 0,
        stock: 0,
        model:"",
        brandName:""
      },
      productNumber: 1,
      Discount: [],
      productValue: [],
      SkuId: '',
      systemStore: {},
      specifica: null,
      evaluate: 0,
      evaluateList: null,
      evaluateCount: 0,
      listPage: 1,
      pageTotal: 0,
      selectAttrArr: [],
      // 商品编号
      storeCode: ''
    }
  },
  computed: {
    ...mapGetters(['currentPro', 'userInfo'])
  },

  methods: {
    ...mapMutations({
      setCurrentPro: 'SET_CURRENTPRO',
      setCartNumber: 'SET_CARTNUMBER',
      setShoppingCart: 'SET_SHOPPINGCART',
			addCartNum: 'addCartNum',
      goByIndex () {
        this.$router.push('/index')
      },
      goByPt () {
        this.$router.push({
          path: '/categoryProduct', query: { id: 1, name: '拼团' }
        })
      },
      goByqg () {
        this.$router.push({
          path: '/categoryProduct', query: {id: 2, name: '抢购'}
        })
      },
      goByjz(){
        this.$router.push({
          path: '/categoryProduct', query: {id: 3, name: '竞争'}
        })
      },
      goByms () {
        this.$router.push({
          path: '/categoryProduct', query: {id: 4, name: '秒杀'}
        })
      },
      goSiteConfig (type) {
        this.$router.push({
          path: '/about', query: {type}
        })
      }
    }),
    // 猜你喜欢
    menuMouseOver () {
      this.showMenu = true
    },
    menuMouseOut () {
      this.showMenu = false
    },
    guessYourLike () {
      let params = {
        url: api.guessYourLike + '?limit=5&page=1',
        method: 'GET'
      }
      this.sendReq(params, (res) => {
        this.similarProducts = res.data
      })
    },
    getProductInfo () {
      const rLoading = this.openLoading()
      let self = this
      // if(self.currentPro.id == undefined){
      //   self.currentPro.id
      // }
      if (!this.storeCode) {
        this.storeCode = ''
      }
      let params = {
        url: api.getProDetail + '/' + self.currentPro.id, // +self.currentPro.id
        method: 'GET',
        payload: {
          latitude: '',
          longitude: '',
          uId: self.userInfo.uid,
          storeCode: self.storeCode
        },
      };
      self.sendReq(params, (res) => {
        if (res.success) {
          self.setCurrentPro(res.data.storeInfo)
          self.productDetailData = res.data.storeInfo
          self.storeCategory = res.data.storeInfo.storeCategory
          self.productOption = res.data.productAttr
          self.productValue = res.data.productValue
          res.data.productAttr.filter(function (item, index, arr) {
            if (arr.length !== 0) {
              self.$set(item.attrValue[0], 'check', true)
            }
          })
          let productAttr1 = []
          res.data.productAttr.forEach(item => {
            productAttr1.push(item.attrValueArr[0])
          })

          self.currentProductData.stock = res.data.productValue[productAttr1.join(',')].stock
          self.currentProductData.price = res.data.productValue[productAttr1.join(',')].price
          self.currentProductData.otPrice = res.data.productValue[productAttr1.join(',')].otPrice
          self.currentProductData.model = res.data.storeInfo.model
          self.currentProductData.brandName= res.data.brandName
          self.selectAttrArr = res.data.productValue[productAttr1.join(',')].sku.split(',')
          self.systemStore = res.data.storeInfo.systemStore

          let reg = new RegExp("'", 'g') // g代表全部
          if (res.data.specs != null && res.data.specs !== 'undefine' && res.data.specs !== '') {
            res.data.specs = res.data.specs.replace(reg, '"')
            this.specifica = JSON.parse(res.data.specs)
          }
          window.scrollTo(0, 0)
          rLoading.close()
        } else {
          self.$message(res.msg)
          self.$router.push('/index')
        }
      })
    },
    getcomment () {
      // 查看评论
      let self = this
      let params = {
        url: api.getReplyList + '/' + self.currentPro.id,
        method: 'GET',
        payload: {
          page: 1,
          limit: 20,
          type: 0 // 0 查看全部 1好评
        }
      }
      self.sendReq(params, (res) => {
        if (res.success) {
          this.evaluateList = res.data;
          this.evaluate =res.data;
          // self.evaluateParam.productId = self.data.productId
          // self.evaluateParam.words = self.data.words
          //self.similarProducts = self.data.similarProducts
        } else {
          self.$message(res.msg);
        }
      });

      let paramsPj = {
        url: api.getReplyCount + "/" + self.currentPro.id,
        method: "GET",
        payload: {
          type: 0, //0 查看全部 1好评
        },
      };
      self.sendReq(paramsPj, (res) => {
        if (res.success) {
          this.evaluateCount=res.data;
        } else {
          self.$message(res.msg);
        }
      });



    },
    getcoupon() {
      let self = this;
      let params = {
        url: api.getCoupontListByCondition,
        method: "GET",
        payload: {
          page: 1,
          limit: 20,
          productId:self.currentPro.id,
          uid:this.userInfo.uid
        },
      };
      if(this.userInfo.uid != null){
        self.sendReq(params, (res) => {
          if (res.success) {
            self.Discount = res.data;
          } else {
            self.$message(res.msg);
          }
        });
      }
    },
    reloadDetail() {
      this.$router.go(0);
      // this.reload()
    },

    // 加入购物车
    clickAddCart() {
			if (!Cookie.get("token")) {
			  this.$message({
			    message: "请先登录",
			  });
			  return this.$router.push({ path: "/login" });
			}

      if (this.currentProductData.stock > 0) {
        let self = this;

        var skuId = "";

        let guige = [];
        // self.productOption.forEach((element) => {
        //   guige.push(element.attrValueArr[0]);
        // });
		    guige = this.selectAttrArr
        Object.values(self.productValue).forEach((element) => {
          if (element.sku == guige) {
            skuId = element.unique;
          }
        });
        let params = {
          url: api.addCart,
          method: "POST",
          data: {
            cartNum: self.productNumber,
            new: 0,
            productId: self.currentPro.id,
            storeCode: self.currentPro.storeCode,
            uniqueId: skuId || this.getSkuId(),
          },
        };
        self.sendReq(params, (res) => {
          if (res.success) {
            self.$message.success("添加成功");
            this.getTrolleyList();
            this.addCartNum(1)
          } else {
            self.$message(res.msg);
          }
        });
      } else {
        this.$message({
          message: "商品库存不足",
        });
      }
    },
    // 购物车列表
    async getTrolleyList() {
      const vm = this;
      const params = {
        url: api.getTrolleyList,
        method: "GET",
        // data: {
        //   numType: 0,
        // },
      };
      vm.sendReq(params, (res) => {
        const d = res.data.valid;
        // let cartNumber = 0;
        // if (d.length) {
        this.setShoppingCart(d);
        //   d.forEach(j => {
        //     cartNumber = cartNumber + j.skus.length
        //   })
        // }
        // cartNumber = d.count;
        // this.setCartNumber(cartNumber);
      });
    },
    clickSwitchTab (type) {
     this.getcomment()
      this.currentComp = type
    },
    handleClick(tab, event) {
    },
    buyGood() {
      let self = this;
      if (this.currentProductData.stock > 0) {
        if (!Cookie.get("token")) {
          this.$message({
            message: "请先登录",
          });
          this.$router.push({ path: "/login" });
        } else {
          var skuId = "";
          let guige = [];
          guige = self.selectAttrArr
          Object.values(self.productValue).forEach((element) => {
            if (element.sku == guige) {
              skuId = element.unique;
            }
          });
          let params = {
            url: api.addCart,
            method: "POST",
            data: {
              cartNum: self.productNumber,
              new: 1,
              storeCode: self.currentPro.storeCode,
              productId: self.currentPro.id,
              uniqueId: skuId || this.getSkuId(),
            },
          };
          self.sendReq(params, (res) => {
            if (res.success) {
              this.$router.push({
                path: "/placeOrder",
                query: {
                  id: res.data.cartId,
									only: 'only'
                },
              });
            } else {
              self.$message(res.msg);
            }
          });

          //const o = this.systemStore
          // let shopsData = [
          //   {
          //     shopId: self.currentPro.id,
          //     skus: [
          //       {
          //         skuId: skuId || this.getSkuId(),
          //         number: this.currentProductData.stock
          //       }
          //     ]
          //   }
          // ]
          // this.$router.push({path: '/placeOrder',
          //   query: {
          //     type: 1,
          //     shops: JSON.stringify(shopsData)
          //   }})
        }
      } else {
        this.$message({
          message: "商品库存不足",
        });
      }
    },
    // 选择规格sku
  selectSku (o, list) {
    let that = this
    list.attrValue.filter(function (item, index, arr) {
      if (list.attrValueArr[index] == o.attr) {
        that.$set(item, 'check', true)
      } else {
        that.$set(item, 'check', false)
      }
    })
    let selectOption = []
    const temp = this.productOption
    temp.forEach((j) => {
      j.attrValue.forEach((k) => {
        if (k.check) {
          selectOption.push(k.attr)
        }
      })
    })
  this.selectAttrArr = selectOption
    let select = selectOption.toString()
    for (let key in this.productValue) {
      if (key === select) {
        this.currentProductData = this.productValue[key]
        that.currentProductData.stock = this.productValue[key].stock
        that.currentProductData.price = this.productValue[key].price
        that.currentProductData.otPrice = this.productValue[key].otPrice
        that.SkuId = this.productValue[key].unique
      }
    }
  },
    // 获取skuId
    getSkuId() {
      return this.SkuId || "";
    },
    // 领取优惠券
    getThisCoupon(item, index) {
      if (item.isUse == false) {
        let self = this;
        let params = {
          url: api.receiveCoupon,
          method: "POST",
          data: {
            couponId: item.cid,
            id:item.id
          },
        };
        self.sendReq(params, (res) => {
          if (res.status == "200") {
            self.$message.success("领取成功");
            item.isUse = true;
            this.$set(this.Discount,index,item);
            item.state = 0;
          } else {
            this.$message.warning(res.msg);
            // self.$message(res.message);
          }
        });
      }else{
        this.$message.warning("不可重复领取");
      }
    },
    thumbsClick(index) {
      this.swiperThumbs.slideTo(index, 300, false);
      this.swiperTop.slideTo(index, 300, false);
    },
    //添加商品收藏
    collect(type){
      let self = this;
      if (!Cookie.get("token")) {
        this.$message({
          message: "请先登录",
        });
        this.$router.push({ path: "/login" });
        return false;
      }
      let params = {
        url: type == "收藏"?api.collectAdd:api.collectDel,
        method: "POST",
        data: {
          id: this.productDetailData.id,
          category:"collect"
        },
      }
      self.sendReq(params, (res) => {
        if (res.status == "200") {
          if(type == "收藏"){
            this.$set(this.productDetailData,"userCollect",true);
          }else{
            this.$set(this.productDetailData,"userCollect",false);
          }
          self.$message.success(type == "收藏"?"添加收藏成功":"取消收藏成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    getUrlKey(name){//获取url 参数
        return decodeURIComponent(
            (new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
    }
  },
  created () {
    // 获取路径上的商品编号
    var storeCode = this.getUrlKey("productId")
    this.storeCode = storeCode
    this.getProductInfo()
    this.getcoupon()
    this.guessYourLike()
  },
  mounted () {
    let paramsMenu = {
      url: api.getCanvasMenu,
      method: 'GET'
    }
    this.sendReq(paramsMenu, (res) => {
      this.categoryMenu = res.data
    })
    this.$nextTick(() => {
      this.swiperTop = this.$refs.swiperTop.swiper;
      this.swiperThumbs = this.$refs.swiperThumbs.swiper;
      this.swiperTop.controller.control = this.swiperThumbs;
      this.swiperThumbs.controller.control = this.swiperTop;

    });
  },
};
</script>

<style lang="scss" scoped>
	.noData {
		position: absolute;
		left: 50%;
		top: 15%;
		transform: translate(-50%,0);
		font-size: 20px;
		color: #999;
	}
.productBox {
  background: #ffffff;
  margin-top: 50px;
  .productConcise {
    margin-bottom: 60px;
    .swiper-box {
      width: 400px;
      position: relative;
      margin-right: 50px;
      float: left;
      .swiper-slide {
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        &.slide-1 {
          background-image: url("../../../static/image/tu1@2x.png");
        }
        &.slide-2 {
          background-image: url("../../../static/image/tu3@2x.png");
        }
        &.slide-3 {
          background-image: url("../../../static/image/tup2@2x.png");
        }
        &.slide-4 {
          background-image: url("../../../static/image/likeProduct1.png");
        }
        &.slide-5 {
          background-image: url("../../../static/image/poornetwork@2x.png");
        }
      }
      .gallery-top {
        height: 75% !important;
        width: 400px;
        left: 0px;
        top: 20px;
        position: absolute;
        right: 0;
        border: 1px solid #eeeeee;
      }

      .swiperThumbsLeft {
        position: absolute;
        left: 0;
        bottom:0;
        box-sizing: border-box;
        padding: 2px 0;
        height: 15%;
        .swiper-slide {
          width: 66px ;
          height: 66px;
        }
        .thumbsBox {
          width: 100%;
          height: 100%;
          position: relative;
        }
      }
      .gallery-thumbs {
        //border: 1px solid #eeeeee;

        position: relative;
        width: 400px;
        height: 100%;
      }
      .gallery-thumbs .swiper-slide {
        width: 100%;
        opacity: 0.7;
      }
      .gallery-thumbs .swiper-slide-active {
        opacity: 1;
        border: 1px solid $mainColor;
        box-sizing: border-box;
      }
    }
    .proDuctInfo {
      width: 678px;
      float: left;
      .productTit {
        margin-top: 25px;
        font-size: 18px;
        color: #333333;
      }
      .introduction {
        color: #999999;
        font-size: 14px;
        line-height: 30px;
        margin: 10px 0;
      }
      .priceDataInfo {
        margin-top: 40px;
        border-top: 1px solid #000000;
        background: #fff8f2;
        padding: 16px 16px 8px 16px;
        height: auto;
        .promotionInfo {
          span:nth-child(1) {
            font-size: 16px;
            color: #999999;
          }
          span:nth-child(2) {
            font-size: 18px;
            color: $mainColor;
          }
          span:nth-child(3) {
            font-size: 16px;
            color: #666666;
            text-decoration: line-through;
          }
        }
        .proDiscount {
          margin-top: 16px;
          .discountInfo {
            span:nth-child(1) {
              font-size: 16px;
              color: #999999;
            }
            span:nth-child(2) {
              font-size: 14px;
              color: $mainColor;
              border: 1px solid $mainColor;
              padding: 0 2px;
              border-radius: 4px;
            }
            span:nth-child(3) {
              font-size: 14px;
              color: #666666;
            }
          }
          .activityLabel {
            padding-left: 53px;
            margin: 20px 0;
            span:nth-child(1) {
              font-size: 14px;
              color: $mainColor;
              border: 1px solid $mainColor;
              padding: 1px 2px;
              border-radius: 4px;
            }
            span:nth-child(2) {
              font-size: 14px;
              color: #666666;
            }
            span:nth-child(3) {
              font-size: 14px;
              color: $mainColor;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }
      }
      .proDescribeTit {
        color: #000000;
        font-size: 16px;
        margin: 18px 0;
      }
      .productColor {
        .proColorList {
          display: flex;
          div {
            border: 1px solid #ffffff;
            padding: 4px;
            margin-right: 15px;
            cursor: pointer;
            span {
              display: block;
              height: 37px;
              width: 37px;
              border: 1px solid #eeeeee;
              img {
                width: 100%;
              }
            }
          }
          div.colorActive {
          }
        }
      }
      .sku-box {
        ul {
          li {
            p {
              &:nth-child(2) {
                span {
                  display: inline-block;
                  padding: 0 10px;
                  height: 32px;
                  line-height: 32px;
                  text-align: center;
                  color: #666666;
                  font-size: 18px;
                  background: #efefef;
                  margin-right: 20px;
                  cursor: pointer;
                }
                .selected-item {
                  background: $mainColor;
                  color: #ffffff;
                }
              }
            }
          }
        }
      }
      .productSize {
        .proSizeList {
          display: flex;
          span {
            padding: 0 10px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            color: #666666;
            font-size: 18px;
            background: #efefef;
            margin-right: 20px;
            cursor: pointer;
          }
          span.sizeActive {
            background: $mainColor;
            color: #ffffff;
          }
        }
      }
      .proNumberList {
        .el-input-number {
          width: 140px;
          margin-right: 25px;
        }
        b {
          font-size: 16px;
          font-weight: 500;
          color: $mainColor;
          padding: 0 5px;
        }
      }
      .buyBox {
        margin-top: 30px;
        display: flex;
        span {
          width: 135px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 16px;
          color: $mainColor;
          border: 1px solid $mainColor;
          margin-right: 10px;
          &:hover {
            cursor: pointer;
          }
        }
        span:nth-child(2) {
          background: $mainColor;
          color: #ffffff;
        }
      }
    }
  }
  >>> .el-tabs--border-card {
    box-shadow: none;
    border: none;
  }
  .productDetail {
    .detailTabs {
      margin-bottom: 30px;
      height: 46px;
      line-height: 46px;
      border: 1px solid #e5e5e5;
      background: #f6f6f6;
      display: flex;
      span {
        padding: 0 30px;
        border-right: 1px solid #e5e5e5;
        cursor: pointer;
        color: #333333;
        font-size: 16px;
      }
      .compActive {
        background: #ffffff;
      }
    }
    .detailBox {
      margin-bottom: 100px;
      .detailInfoBox {
        width: 890px;
        float: left;
        min-height: 1200px;
        border-right: 1px solid #cacaca;
		position: relative;
      }
      .likeProductBox {
        width: 280px;
        float: left;
        padding-left: 44px;
      }
    }
  }
  .evaluateTime{
    margin: 5px 0px;
    // font-size: 14px;
    // color: gray;
  }
}
.el-row {
  // width: 890px;
  margin-bottom: 20px;
  border-bottom: 1px solid #99a9bf;
  font-size: 15px;
  color: #99a9bf;
  padding-bottom: 10px;
}
.el-col {
  text-align: center;
  // width: 80px;
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
/* .bg-purple {
  background: #d3dce6;
} */
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 25px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.detailContent /deep/img{
  width: 889px;
}
</style>

<style lang="scss" scoped>

// .el-row {
//   width: 890px;
//   margin-bottom: 20px;
//   border-bottom: 1px solid #99a9bf;
//   font-size: 15px;
//   color: #99a9bf;
//   padding-bottom: 10px;
// }
// .el-col {
//   text-align: center;
//   width: 80px;
//   border-radius: 4px;
// }
// .bg-purple-dark {
//   background: #99a9bf;
// }
// /* .bg-purple {
//   background: #d3dce6;
// } */
// .bg-purple-light {
//   background: #e5e9f2;
// }
// .grid-content {
//   border-radius: 4px;
//   min-height: 25px;
// }
// .row-bg {
//   padding: 10px 0;
//   background-color: #f9fafc;
// }


/* 商品详情分级样式 */
.head {
  margin-top: 32px;
  width: 100%;
  height: 84px;
  line-height: 84px;
  font-size: 16px;
  display: flex;
  align-items: center;
  background: #FFFFFF;
  .all {
    margin-right: 6px;
    margin-left: 0px;
  }
  .keyword {
    margin: 0 6px;
    color: #0060A5;
  }
  .arrow {
    background-image: url('../../../static/image/xiangyou@2x.png');
    width: 5px;
    height: 10px;
  }
}

.lists{
  width: 100%;
  height: 35px;
  color: #fff;
  background-color: #d22929;
  display: flex;
}
.lists h3{
 width: 208px;
 height: 35px;
 display: block;
 line-height: 35px;
 text-align: center;
 //font-weight: 700;
 font-size: 22px;
 color: white;
 background-color: #000000;
}
.lists ul{
 width: 1000px;
 height: 35px;
 display: flex;
 list-style-type: none;
}
.lists li{
 width: 80px;
 height: 35px;
 text-align: center;
 line-height: 35px;
 display: block;
 float: left;
 margin-right: 1px;
 font-size: 16px;
  padding-left: 10px;
  padding-right: 10px
 //font-weight: 700;
}
.one{
 margin-left: 20px;
}
.lists ul li:hover {
  color: #fff;
  background-color: #fe550c;
}
.warp1{
  width: 100%;
  margin: 0 auto;
  border-bottom-color: #FFFFFF;
  border-bottom: 1px solid #FFFFFF;
}

.prop-item {
  line-height: 26px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.prop-service {
  padding-bottom: 10px;
}
.prop-item dt {
  width: 70px;
  float: left;
  font-size: 14px;
}
.prop-item dd {
  width: 450px;
  float: left;
  font-size: 12px;
  .selected-item {
    display: inline-block;
    padding: 0 10px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    //color: #666666;
    font-size: 12px;
    background: #efefef;
    //margin-right: 20px;
    cursor: pointer;
    background: $mainColor;
    color: #ffffff;
  }
}
.prop-item dd >>>.el-input__inner{
  line-height: 26px;
  height: 26px;
}
.prop-item dd >>> .el-input-number{
  line-height: 26px;
  height: 26px;
}
.fl {
  float: left;
}
.stock-red {
  color: #0060A5;
}
.productNumber {
  //margin-top: 15px;
}
.conte1{
  width: 1250px;
  display: flex;
}
.conte1 .header_xuan{
  //width: 1250px;
  margin: 0 auto;
  position: absolute;
  z-index: 3;
  left: 15.7%;
}

.classification{
  //background: #f1f2f7;
  top: 1.5px;
  height: 470px;
  color: #000;
  position: relative;
  ul{
    li{
      line-height: 42px;
      padding: 0 13.5px;
      width:208px;
      .item{
        cursor: pointer;
        font-size: 14px;
        padding:0 0 0 30px;
      }
      .icon{
        float: right;
        line-height: 42px;
      }
      .hoverBox{
        position: absolute;
        width: 1000px;
        padding:10px 25px;
        height: 1000px;
        left: 100%;
        top: 1.5px;
        z-index: 3;
        display: none;
        background-color: #FFFFFF;
        color: #333;
        //border: 2px solid $mainColor;
        overflow-x: hidden;
        // overflow: scroll-y;
        .over{
          width: 1000px;
          padding:10px;
          height: 800px;
        }
        dl{
          margin-bottom: 5px;
          dt{
            height: 34px;
            line-height: 34px;
            font-size: 16px;
            color: #333;
            font-weight: bold;
            border-bottom: 1px dashed rgba(200,200,200,0.5);
          }
          dd{
            line-height: 26px;
            font-size: 12px;
            margin-left: 0;
            a{
              margin-right: 12px;
              &:hover{
                color: $mainColor;
              }
            }
          }
        }
      }
      &:hover{
        color: $mainColor;
        .hoverBox{
          display: block;
        }
      }
    }
  }
}

.likeProItem{
  padding: 15px 10px;
  background-color: white;
}
.main_shop1{
  margin-top: 0;
  background-color: #f3f5f6;
  padding: 15px 0px;
}
.main_shop1:hover {
  transform: scale(1.1);
  box-shadow: 2px 2px 1px #e4e4e4;
}
.caidan{
  margin-left: 0;
  width: 208px;
;
}
.caidan_div{
  margin-left: 54px;
  margin-right: 20px;
}

.itemMenu1 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px 0px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}

.itemMenu2 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -30px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
.itemMenu3 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -60px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
.itemMenu4 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -90px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
.itemMenu5 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -120px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
.itemMenu6 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -150px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
.itemMenu7 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -180px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
.itemMenu8 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -210px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
.itemMenu9 {
  background-image:url(../../../static/image/menu_cate.png);
  width: 16px;
  height: 32px;
  background-position: 0px -240px;
  margin-top: 6px;
  margin-right: 10px;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/views/product/productDetail.vue